<template>
    <button :class="btnClasses" :disabled="isDisabled" @click.prevent="doClick">
        <span v-if="isLoading">
            <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="20px"
                height="20px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve">
                <path
                    fill="currentColor"
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite" />
                </path>
            </svg>
        </span>
        <span>
            <slot v-if="!isLoading && !isSuccess && !isError">{{ $t('save') }}</slot>
        </span>
        <span v-if="isLoading">{{ textLoading ? textLoading : $t('saving') }}</span>
        <span v-if="isSuccess">{{ textIsSuccess ? textIsSuccess : $t('saved') }}!</span>
        <span v-if="isError">{{ $t('error') }}</span>
    </button>
</template>

<script>
/*
Use events to change it's state:
document.dispatchEvent(new Event(`${result.eventName}.isSuccess`));
document.dispatchEvent(new CustomEvent(`${result.eventName}.isError`, { detail: e }));
*/

export default {
    name: 'ButtonSave',
    props: {
        onClick: {
            type: Function,
            required: true,
        },
        classes: {
            type: String,
            default: 'button is-success',
        },
        iniDisabled: {
            type: Boolean,
        },
        eventName: {
            type: String,
            required: true,
        },
        autoLoading: {
            type: Boolean,
            default: true,
        },
        textIsSuccess: {
            type: String,
        },
        textLoading: {
            type: String,
        },
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            isError: false,
        };
    },
    computed: {
        isDisabled() {
            return this.iniDisabled || this.isLoading;
        },
        btnClasses() {
            let classes = this.classes;

            if (this.isError) {
                classes = 'button is-danger';
            } else if (this.isSuccess) {
                classes = 'button is-success';
            }
            if (this.isLoading) {
                classes += ' isLoading';
            }
            //check if this.classes has 'is-small'
            if (this.classes.includes('is-small')) {
                classes += ' is-small';
            }
            if (this.classes.includes('is-large')) {
                classes += ' is-large';
            }
            return classes;
        },
    },
    created: function () {
        document.addEventListener(`${this.eventName}.isLoading`, this.onLoading);
        document.addEventListener(`${this.eventName}.isSuccess`, this.onSuccess);
        document.addEventListener(`${this.eventName}.isError`, this.onError);
    },
    beforeDestroy() {
        document.removeEventListener(`${this.eventName}.isLoading`, this.onLoading);
        document.removeEventListener(`${this.eventName}.isSuccess`, this.onSuccess);
        document.removeEventListener(`${this.eventName}.isError`, this.onError);
    },
    methods: {
        onLoading(value) {
            if (typeof value === 'boolean') {
                this.isLoading = value;
            } else {
                this.isLoading = true;
            }
        },
        onError() {
            this.isLoading = false;
            this.isSuccess = false;
            this.isError = true;
            setTimeout(() => {
                this.isError = false;
            }, 5000);
        },
        onSuccess() {
            this.isLoading = false;
            this.isSuccess = true;
            setTimeout(() => {
                this.isSuccess = false;
            }, 3000);
        },
        doClick() {
            //only do the click when button is enabled.
            if (!this.isDisabled) {
                this.onClick({
                    eventName: this.eventName,
                    result: true,
                });
                if (this.autoLoading) {
                    this.isLoading = true;
                }
            }
        },
    },
    i18n: {
        messages: {
            en: {
                save: 'Save',
                saving: 'Saving',
                saved: 'Saved',
                error: 'Error',
            },
            fr: {
                save: 'Sauver',
                saving: 'Sauver',
                saved: 'Sauvegardé',
                error: 'Erreur',
            },
            nl: {
                save: 'Opslaan',
                saving: 'Opslaan',
                saved: 'Opgeslagen',
                error: 'Fout',
            },
        },
    },
};
</script>
